import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { hasAnalyticsConsent } from '../lib/consent';
import { trackEvent } from '../services/analyticsService';

function trackCurrentPage(location) {
  if (!hasAnalyticsConsent() || typeof window === 'undefined') {
    return;
  }

  trackEvent('page_view', {
    page_path: `${location.pathname}${location.search}`,
    page_location: window.location.href,
    page_title: document.title,
  });
}

export default function AnalyticsPageTracker() {
  const location = useLocation();

  useEffect(() => {
    trackCurrentPage(location);
  }, [location]);

  useEffect(() => {
    const handleConsentChange = () => {
      trackCurrentPage(location);
    };

    window.addEventListener('aprendos:consentchange', handleConsentChange);
    return () => window.removeEventListener('aprendos:consentchange', handleConsentChange);
  }, [location]);

  return null;
}
